module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/unzip_imgs.worker.633436a5166c42049297.js");
}
